export default __webpack_public_path__ + "static/media/LakmeIndia1.8d124778.png";